import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterGippel() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-gippel-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-gippel-heading">WETTER</h1>
        </div>

        <Wetter ort="gippel" />
      </div>
    </div>
  );
}

export default WetterGippel;
